import {getWidgetData as getWidgetDataServerless} from '@wix/ambassador-events-ui-v1-widget-data/http'
import {
  EventFilter,
  EventSortOrder,
  GetWidgetDataRequest,
  GetWidgetDataResponse,
  ListLayout,
  RecurringFilter,
  WidgetType,
} from '@wix/ambassador-events-ui-v1-widget-data/types'
import {
  EVENT_FILTER_TYPE,
  EVENT_SORT_ORDER,
  EventsHttpClient,
  LIST_LAYOUT,
  RECURRING_FILTER,
  WIDGET_TYPE,
} from '@wix/wix-events-commons-statics'
import {GetWidgetDataParams} from './shared-api'

// Mapping is temporarily done here for new api
// Later code will be refactored step by step to avoid this mapping
export const getServerlessWidgetDataAdapter =
  (api: EventsHttpClient) =>
  async ({
    responsive = false,
    locale,
    language,
    compId,
    viewMode,
    members,
    paidPlans,
    widgetType,
    listLayout,
    recurringFilter,
    showcase = false,
    tz,
    filterType,
    sortOrder,
    categoryId,
    limit,
    fetchCategoryId,
    fetchAllCategories,
    editor3,
  }: GetWidgetDataParams): Promise<GetWidgetDataResponse> => {
    let categoryIds: string[] | undefined

    if (categoryId !== undefined) {
      categoryIds = Array.isArray(categoryId) ? categoryId : [categoryId]
    }

    const eventFilterMap: Record<EVENT_FILTER_TYPE, EventFilter> = {
      [EVENT_FILTER_TYPE.MANUAL]: EventFilter.MANUAL,
      [EVENT_FILTER_TYPE.PAST]: EventFilter.PAST,
      [EVENT_FILTER_TYPE.UPCOMING]: EventFilter.UPCOMING,
      [EVENT_FILTER_TYPE.UPCOMING_AND_PAST]: EventFilter.UPCOMING_AND_PAST,
    }

    const eventFilter = eventFilterMap[filterType]

    const listLayoutMap: Record<LIST_LAYOUT, ListLayout> = {
      [LIST_LAYOUT.LIST]: ListLayout.LIST,
      [LIST_LAYOUT.GRID]: ListLayout.GRID,
      [LIST_LAYOUT.NEW_GRID]: ListLayout.NEW_GRID,
      [LIST_LAYOUT.SIDE_BY_SIDE]: ListLayout.SIDE_BY_SIDE,
      [LIST_LAYOUT.CALENDAR]: ListLayout.CALENDAR,
      [LIST_LAYOUT.ON_IMAGE]: ListLayout.ON_IMAGE,
    }

    const recurringFilterMap: Record<RECURRING_FILTER, RecurringFilter> = {
      [RECURRING_FILTER.COLLAPSED]: RecurringFilter.COLLAPSED,
      [RECURRING_FILTER.ALL]: RecurringFilter.ALL,
    }

    const sortOrderMap: Record<EVENT_SORT_ORDER, EventSortOrder> = {
      [EVENT_SORT_ORDER.MANUAL]: EventSortOrder.MANUAL_SORT,
      [EVENT_SORT_ORDER.CHRONOLOGICAL]: EventSortOrder.CHRONOLOGICAL,
    }

    const widgetTypeMap: Record<WIDGET_TYPE, WidgetType> = {
      [WIDGET_TYPE.FEATURED]: WidgetType.FEATURED,
      [WIDGET_TYPE.LIST]: WidgetType.MULTIPLE,
      [WIDGET_TYPE.SINGLE]: WidgetType.SINGLE,
    }

    const serverlessResponse = await getServerlessWidgetData(api)({
      compId,
      categoryIds,
      eventFilter,
      fetchAllCategories,
      fetchBadges: true,
      fetchCategoryIds: fetchCategoryId,
      fetchMembers: members,
      fetchPaidPlans: paidPlans,
      language,
      limit,
      listLayout: listLayoutMap[listLayout],
      locale,
      recurringFilter: recurringFilterMap[recurringFilter],
      responsive,
      showcase,
      sortOrder: sortOrderMap[sortOrder],
      tz,
      viewMode,
      widgetType: widgetTypeMap[widgetType],
      editor3,
    })

    return serverlessResponse
  }

export const getServerlessWidgetData =
  (api: EventsHttpClient) =>
  async (args: GetWidgetDataRequest): Promise<GetWidgetDataResponse> => {
    return api.request(
      getWidgetDataServerless({
        ...args,
        ...(args.listLayout === ListLayout.CALENDAR && {
          today: new Date().toLocaleDateString('en-CA', {timeZone: args.tz}), // So the cache resets at least everyday
        }),
      }),
    )
  }
